import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'maintenanceStatus'   
})
export class MaintenanceStatusPipe implements PipeTransform {

  transform(value: any): string {
    if (!value) {
      return 'NA';
    }

    const today = moment().endOf('day');
    const maintenanceDate = moment(value, 'DD MMM YYYY').endOf('day');

    if (!maintenanceDate.isValid()) {
      return 'NA';
    }

    if (maintenanceDate.isBefore(today)) {
      return 'Overdue';
    } else {
      return 'Upcoming';
    }
  }

}
